<template>
  <card>
    <list
      v-if="$store.state.user.sections['registry_reports']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="fileFields.length > 0"
      :itemLink="itemLink"
      :setLink="setLink"
      :dateFilter="dateFilter"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  mounted() {
    this.getFileFields();
  },
  methods: {
    changeFunction(val) {},
    change(val) {},
    async getFileFields() {
      await this.$http.get("registry_templates").then((response) => {
        this.fileFields = response.data.data;
        for (let i = 0; i < this.fileFields.length; i++) {
          this.fields.push({
            col: " col-12 col-md-6",
            key: this.fileFields[i].code,
            label: this.fileFields[i].name,
            type: "zip",
          });
        }
      });
    },
  },
  data() {
    return {
      fileFields: [],
      params: {},
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      val: [],
      modalCreate: "registry_reports",
      fields: [
        {
          col: " col-12 col-md-12",
          key: "file",
          label: "EXCEL SBI ",
          type: "zip",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_registry_report",
      itemLink: "registry_reports",
      setLink: "registry_reports",
      columns: [
        {
          detail: true,
        },

        {
          key: "id",

          title: "ID запроса",
        },
        {
          key: "user",
          object: "name",
          title: "Создал запрос",
        },
        {
          key: "media",
          title: "Документы",
          media: true,
        },
        {
          key: "created_at",
          dateTimeFormat: true,
          title: "Дата запроса",
        },
      
      ],
    };
  },
};
</script>
<style>
</style>
